import {
    RiEmotionHappyLine,
    RiEmotionNormalLine,
    RiEmotionUnhappyLine,
} from 'react-icons/ri';
import { getScoreColor } from 'utils/helpers';
import { tooltips } from '@/copy';

export const getSentimentBadgeProps = (score) => {
    const fgColor = getScoreColor(score, true, 'sentiment score');
    const titlesByScore = tooltips.healthStats['sentiment score'].scoreLabels;
    switch (true) {
        case score >= 8:
            return {
                Icon: RiEmotionHappyLine,
                bgColor: 'green_50',
                fgColor,
                title: titlesByScore[8],
            };
        case score >= 4:
            return {
                Icon: RiEmotionNormalLine,
                bgColor: 'orange_50',
                fgColor,
                title: titlesByScore[4],
            };
        case score < 4:
            return {
                Icon: RiEmotionUnhappyLine,
                bgColor: 'red_50',
                fgColor,
                title: titlesByScore[0],
            };
        default:
            return {};
    }
};
